export const roles = (roles) => {
    let allRoles = [];
    roles.forEach((value) => {
        allRoles.push({ value: value?.id, text: value?.rolename });
    });
    return allRoles;
  };
  